import Vue from 'vue'
const state = {
  serviceWorkerReady: false,
  actualPage: null,
  networkState: null,
  isWifi: null,
  simInfo: null,
  utils: {},
  foundUpdate: false,
  updateIsReady: false,
  closeModalByBack: false,
  modalWasRoutable: false,
  versionAPK: null,
  os: null,
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  setServiceWorkerReady (state) {
    state.serviceWorkerReady = true
  },
  setProp (state, obj) {
    state[obj.prop] = obj.val
  },
  setPage (state, route) {
    state.actualPage = route.path
  },
  setCordovaInfo (state, info) {
    state.versionAPK = info.version
    state.os = info.os
  },
  setSimInfo (state, simInfo) {
    state.simInfo = simInfo
  },
  setLocatedAddress (state, location) {
    Vue.set(state.utils, 'locatedAddress', location)
  },
  setCloseModalByBack (state, value) {
    Vue.set(state, 'closeModalByBack', value)
  },
  setModalWasRoutable (state, value) {
    Vue.set(state, 'modalWasRoutable', value)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
